<template>
  <div>
    <base-card>
      <v-card-text>
        <v-form ref="form">
          <base-card>
            <v-row>
              <v-col cols="12" sm="4">
                <v-card-title>Configuración Formatos DIAN</v-card-title>
              </v-col>
              <v-col cols="12" sm="8" class="text-end mt-5">
                <v-btn
                  color="rgb(204 33 40)"
                  class="white--text border-button px-8 py-4"
                  min-width="180"
                  @click="copyFormats()"
                >
                  Importar configuración
                </v-btn>
                &nbsp;
                <v-btn
                  color="rgb(204 33 40)"
                  class="white--text border-button px-8 py-4"
                  min-width="180"
                  @click="openModalTaxes()"
                >
                  Configuración impuestos
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12">
                <div class="line-text">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="3">
                        <div>Año:</div>
                        <v-select
                          v-model="dataFilter.year"
                          :items="years"
                          item-text="text"
                          item-value="value"
                          prepend-inner-icon="mdi mdi-calendar-range"
                          required
                          dense
                          outlined
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <div>Formato:</div>
                        <v-select
                          v-model="dataFilter.format"
                          :items="formats"
                          item-text="description"
                          item-value="id"
                          prepend-inner-icon="mdi mdi-format-align-justify"
                          required
                          dense
                          outlined
                        />
                      </v-col>
                      <v-col cols="12" sm="3">
                        <div>Empresa contable:</div>
                        <v-text-field
                          v-model="accountingCompanies"
                          dense
                          outlined
                          hide-details
                          type="text"
                          prepend-inner-icon="mdi mdi-domain"
                          disabled
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- <v-col cols="12" md="9">
                      <v-row align="center" class="flex-wrap">
                        <v-col cols="12" class="d-flex">
                          <span class="mt-1">
                            Si el saldo de los pasivos o créditos es menor o igual a
                          </span>
                          <v-text-field
                            v-model="dataCredentials.topeLimite"
                            dense
                            outlined
                            hide-details
                            type="number"
                            class="mx-2"
                            style="max-width: 150px"
                          />
                          <span class="mt-1">, utilizar el tope A:</span>
                          <v-text-field
                            v-model="dataCredentials.topeA"
                            dense
                            outlined
                            hide-details
                            type="number"
                            class="mx-2"
                            style="max-width: 150px"
                          />
                          <span class="mt-1">, si no, utilizar el tope B:</span>
                          <v-text-field
                            v-model="dataCredentials.topeB"
                            dense
                            outlined
                            hide-details
                            type="number"
                            class="mx-2"
                            style="max-width: 150px"
                          />
                        </v-col>
                      </v-row>

                      <v-row class="mt-1">
                        <v-col cols="12">
                          <span>
                            Estos topes sólo se usan en los formatos 1008 y 1009
                            para la validación de cuantías menores a partir de los
                            pasivos. Para los demás formatos, utilice el campo "TOPE
                            MENOR CUANTÍA".
                          </span>
                        </v-col>
                      </v-row>
                    </v-col> -->
                      <v-col cols="12" md="9" class="d-flex">
                        <p class="tam-p mt-1">
                          Unificar clientes con datos incompletos en cuantías
                          menores:
                        </p>
                        &nbsp;&nbsp;&nbsp;
                        <v-select
                          v-model="dataCredentials.appliesGroupingByLackData"
                          :items="optionsMiniorAccount"
                          item-text="text"
                          item-value="value"
                          required
                          outlined
                          dense
                          hide-details
                          style="max-width: fit-content;"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        class="d-flex justify-end align-start"
                      >
                        <v-btn
                          color="rgb(204 33 40)"
                          class="white--text border-button"
                          @click="saveConfigImport()"
                          :disabled="this.disableBottomSave"
                        >
                          <v-icon left>mdi-content-save-edit-outline</v-icon>
                          Guardar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-row justify="center" class="my-4" v-if="showAlert">
                    <v-col cols="12" sm="6">
                      <v-alert
                        :type="alertType"
                        dense
                        outlined
                        border="left"
                        colored-border
                        class="my-4"
                      >
                        {{ alertMessage }}
                      </v-alert>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <v-card-text class="mt-5 line-text">
              <v-toolbar flat dense>
                <v-toolbar-title class="d-flex">
                  <v-btn
                    outlined
                    color="rgb(204 33 40)"
                    class="border-button"
                    @click="openConceptModal"
                  >
                    <v-icon left>mdi mdi-plus-box-multiple-outline</v-icon>
                    Añadir
                  </v-btn>
                </v-toolbar-title>
                <v-row justify="center">
                  <v-col cols="12" sm="8" class="my-4">
                    <v-alert
                      v-if="showAlertTable"
                      :type="alertTypeTable"
                      dense
                      outlined
                      border="left"
                      colored-border
                      class="my-4"
                    >
                      {{ alertMessageTable }}
                    </v-alert>
                  </v-col>
                </v-row>
              </v-toolbar>

              <v-data-table
                :headers="headers"
                :items="dataTable"
                :search="search"
                :loading="loadingTable"
                loading-text="Cargando Importaciones..."
                class="elevation-1 mt-5"
              >
                <template v-slot:[`item.startAccount`]="{ item }">
                  <v-select
                    v-model="item.startAccount"
                    :items="filterAccountingAccountStart"
                    item-text="text"
                    item-value="value"
                    required
                    dense
                    outlined
                    filter
                    search-input
                    hide-details
                  >
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-text-field
                              class="search-field"
                              v-model="searchAccountingAccountStart"
                              placeholder="Buscar"
                              prepend-inner-icon="mdi-magnify"
                              hide-details
                            />
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </template>
                <template v-slot:[`item.endAccount`]="{ item }">
                  <v-select
                    v-model="item.endAccount"
                    :items="filterAccountingAccountEnd"
                    item-text="text"
                    item-value="value"
                    required
                    dense
                    outlined
                    filter
                    search-input
                    hide-details
                  >
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-text-field
                              class="search-field"
                              v-model="searchAccountingAccountEnd"
                              placeholder="Buscar"
                              prepend-inner-icon="mdi-magnify"
                              hide-details
                            />
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </template>
                <template v-slot:[`item.formatColumnId`]="{ item }">
                  <v-select
                    v-model="item.formatColumnId"
                    :items="filterReportValueColumn"
                    item-text="text"
                    item-value="value"
                    required
                    dense
                    outlined
                    filter
                    search-input
                    hide-details
                  >
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-text-field
                              class="search-field"
                              v-model="searchReportValueColumn"
                              placeholder="Buscar"
                              prepend-inner-icon="mdi-magnify"
                              hide-details
                            />
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </template>
                <template v-slot:[`item.appliesTopAmount`]="{ item }">
                  <v-select
                    v-model="item.appliesTopAmount"
                    :items="optionsMiniorAccount"
                    item-text="text"
                    item-value="value"
                    required
                    outlined
                    dense
                    hide-details
                  />
                </template>
                <template v-slot:[`item.topAmount`]="{ item }">
                  <v-text-field
                    v-model="item.topAmount"
                    dense
                    outlined
                    hide-details
                    type="number"
                  />
                </template>
                <template v-slot:[`item.calculationTypeId`]="{ item }">
                  <v-select
                    v-model="item.calculationTypeId"
                    :items="filterOriginValue"
                    item-text="description"
                    item-value="calculationTypeId"
                    required
                    dense
                    outlined
                    filter
                    search-input
                    hide-details
                  >
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-text-field
                              class="search-field"
                              v-model="searchOriginValue"
                              placeholder="Buscar"
                              prepend-inner-icon="mdi-magnify"
                              hide-details
                            />
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </template>
                <template v-slot:[`item.ivaMayorValorCosto`]="{ item }">
                  <v-select
                    v-model="item.ivaMayorValorCosto"
                    :items="optionsMiniorAccount"
                    item-text="text"
                    item-value="value"
                    required
                    outlined
                    dense
                    hide-details
                  />
                </template>
                <template v-slot:[`item.hconceptsCfg`]="{ item, index }">
                  <v-btn
                    outlined
                    color="rgb(204 33 40)"
                    class="border-button"
                    @click="addConceptAccounting(item, index)"
                  >
                    <v-icon>mdi mdi-tab-plus</v-icon>
                  </v-btn>
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                  <v-btn
                    outlined
                    color="rgb(204 33 40)"
                    class="border-button"
                    @click="deleteConcept(item)"
                  >
                    <v-icon>mdi mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </base-card>
        </v-form>
      </v-card-text>
    </base-card>
    <v-overlay :value="loading" absolute opacity="0.6">
      <v-progress-circular
        indeterminate
        size="64"
        color="rgb(204 33 40)"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="showModalExist" persistent max-width="500">
      <v-card class="pa-6">
        <v-card-text class="text-center">
          <p class="mb-4 font-weight-medium">
            Se requiere que cuente con cuentas para generar algun tipo de
            confirguracion.
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalConcept" persistent max-width="500">
      <v-card class="pa-6">
        <v-card-title class="just-cen">
          <h4>Agregar Concepto</h4>
        </v-card-title>
        <v-card-text class="text-center mt-3">
          <v-select
            v-model="conceptItem"
            :items="filterAccountingConcept"
            item-text="text"
            item-value="value"
            required
            dense
            outlined
            filter
            search-input
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-text-field
                      class="search-field"
                      v-model="searchAccountingConcept"
                      placeholder="Buscar"
                      prepend-inner-icon="mdi-magnify"
                      hide-details
                    />
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="showModalConcept = false"> Cancelar </v-btn>

          <v-btn
            color="rgb(204 33 40)"
            class="white--text"
            @click="addConceptToTable"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalConceptAccounting" persistent max-width="500">
      <v-card class="pa-6">
        <v-card-title class="just-cen">
          <h4>Agregar Conceptos Contables</h4>
        </v-card-title>
        <v-card-text class="text-center mt-3">
          <v-select
            v-model="conceptAccountingItem"
            :items="filterHConcept"
            item-text="text"
            item-value="value"
            required
            dense
            outlined
            filter
            search-input
            multiple
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-text-field
                      class="search-field"
                      v-model="searchHConcept"
                      placeholder="Buscar"
                      prepend-inner-icon="mdi-magnify"
                      hide-details
                    />
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="showModalConceptAccounting = false">
            Cancelar
          </v-btn>

          <v-btn
            color="rgb(204 33 40)"
            class="white--text"
            @click="addConceptAccountingToTable"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalCopyFormat" max-width="600px" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          <span class="text-h6">Copiar Configuración</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="showModalCopyFormat = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <div class="mb-1 font-weight-medium">Año origen</div>
              <v-select
                v-model="dataCopy.from"
                :items="years"
                item-text="text"
                item-value="value"
                prepend-inner-icon="mdi-calendar-range"
                dense
                outlined
              />
            </v-col>

            <v-col cols="12" md="6">
              <div class="mb-1 font-weight-medium">Año destino</div>
              <v-select
                v-model="dataCopy.to"
                :items="yearsTo"
                item-text="text"
                item-value="value"
                prepend-inner-icon="mdi-calendar-range"
                dense
                outlined
                :disabled="this.disabledTo"
              />
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12">
              <div class="mb-1 font-weight-medium">Formatos a copiar</div>
              <v-select
                v-model="dataCopy.formats"
                :items="formats"
                item-text="description"
                item-value="id"
                prepend-inner-icon="mdi-format-align-justify"
                dense
                outlined
                multiple
                chips
                class="max-height-select"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-end">
          <v-btn text @click="showModalCopyFormat = false"> Cancelar </v-btn>

          <v-btn
            color="rgb(204 33 40)"
            class="white--text"
            @click.prevent="copyFormatsYear"
          >
            <v-icon left>mdi-content-copy</v-icon>
            Enviar a Copiar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalTaxes" max-width="800px" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          <span>Iva Mayor Valor Del Costo</span>
          <v-spacer></v-spacer>
          <v-btn icon @click.prevent="closeModalTax">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <div class="dis-div mt-3">
            <v-row justify="center">
              <v-text-field
                v-model="searchModalTaxes"
                append-icon="mdi-magnify"
                hide-details
                label="Buscar Impuesto"
                single-line
                class="r-search"
              />
            </v-row>
          </div>
          <v-row class="permiso-lista mt-3" justify="start">
            <v-col
              v-for="p in filteredTaxes"
              :key="p.HTaxCode"
              cols="12"
              sm="6"
              md="6"
            >
              <v-card class="permiso-card" elevation="3">
                <v-card-text class="d-flex align-center bcard">
                  <v-checkbox
                    v-model="selectedTaxes"
                    :value="p.id"
                    hide-details
                    class=""
                    style="margin-top: inherit"
                    color="rgb(204 33 40)"
                  ></v-checkbox>
                  <div class="div-b-c">
                    <span>{{ p.percentage }}%</span>
                    <p class="tam-p">{{ p.description }}</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-end">
          <v-btn text @click.prevent="closeModalTax"> Cancelar </v-btn>

          <v-btn
            color="rgb(204 33 40)"
            class="white--text"
            @click.prevent="saveConfigTaxes"
          >
            <v-icon left>mdi mdi-content-save-check-outline</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { environment } from "@/data/environment";

export default {
  data() {
    return {
      showModalConceptAccounting: false,
      showModalConcept: false,
      entities: [],

      dataFilter: {
        year: null,
        format: null,
      },
      optionsMiniorAccount: [
        { text: "Si", value: true },
        { text: "No", value: false },
      ],
      accountingAccountOptions: [],
      searchAccountingAccountStart: "",
      searchAccountingAccountEnd: "",
      reportValueColumnOptions: [],
      searchReportValueColumn: "",
      optionsOriginValue: [],
      searchOriginValue: "",
      accountingConceptOptions: [],
      searchAccountingConcept: "",
      searchHConcept: "",
      conceptItem: [],
      conceptAccountingItem: [],
      headers: [
        {
          text: "CONCEPTO",
          value: "conceptDescription2",
          align: "center",
          width: 250,
        },
        {
          text: "CUENTA INICIAL",
          value: "startAccount",
          align: "center",
        },
        {
          text: "CUENTA FINAL",
          value: "endAccount",
          align: "center",
        },
        {
          text: "REPORTAR VALOR EN LA COLUMNA",
          value: "formatColumnId",
          align: "center",
        },
        {
          text: "APLICA MENOR CUANTIA",
          value: "appliesTopAmount",
          align: "center",
        },
        {
          text: "TOPE MENOR CUANTIA",
          value: "topAmount",
          align: "center",
          width: 150,
        },
        { text: "ORIGEN VALOR", value: "calculationTypeId", align: "center" },
        {
          text: "IVA MAYOR VALOR DEL COSTO",
          value: "ivaMayorValorCosto",
          align: "center",
        },
        {
          text: "CONCEPTOS CONTABLES",
          value: "hconceptsCfg",
          align: "center",
        },
        { text: "QUITAR", value: "delete", align: "center" },
      ],

      token: null,
      showAlert: false,
      alertMessage: "",
      alertType: "success",
      loading: false,
      loadingTable: false,
      dataTable: [],
      idCompany: null,
      requiredRule: [(v) => !!v || "Campo obligatorio"],
      years: [],
      dataCredentials: {
        topeLimite: 0,
        topeA: 0,
        topeB: 0,
        appliesGroupingByLackData: false,
      },
      formats: [],
      showModalExist: false,
      showAlertTable: false,
      alertMessageTable: "",
      alertTypeTable: "success",
      yearModal: "",
      indexConceptAccounting: null,
      lastQueryKey: null,
      fetchTimeout: null,
      disableBottomSave: true,
      showModalCopyFormat: false,
      showModalTaxes: false,
      dataCopy: {
        from: null,
        to: null,
        formats: [],
      },
      disabledTo: true,
      yearsTo: [],
      accountingCompanies: null,
      hConcepts: [],
      hConceptsAmount: [],
      search: "",
      searchModalTaxes: "",
      hTaxes: [],
      selectedTaxes: []
    };
  },
  watch: {
    "dataFilter.format"(newValue) {
      if (!newValue) {
        this.accountingConceptOptions = [];
        this.reportValueColumnOptions = [];
        return;
      }
      this.dataTable = [];
      const selectedFormat = this.formats.find((f) => f.id === newValue);

      if (!selectedFormat || !selectedFormat.concepts) {
        this.accountingConceptOptions = [];
        this.reportValueColumnOptions = [];
        return;
      }

      this.accountingConceptOptions = selectedFormat.concepts.map((c) => ({
        text: c.conceptCode + " - " + c.description,
        value: c,
      }));

      this.reportValueColumnOptions = selectedFormat.columns
        .filter((c) => c.isCalculated)
        .map((c) => ({
          text: c.columnCode + " - " + c.description,
          value: c.id,
        }));

      this.tryFetchConfiguration();
    },
    "dataFilter.year"() {
      this.tryFetchConfiguration();
    },
    dataTable: {
      handler(newVal) {
        this.disableBottomSave = !(newVal && newVal.length > 0);
      },
      deep: true,
    },
    "dataCopy.from"(newVal) {
      if (!newVal) {
        this.yearsComplete = this.yearsComplete;
        return;
      }
      this.disabledTo = false;
      const currentYear = new Date().getFullYear();

      let yearsComplete = Array.from({ length: 10 }, (_, i) => {
        const year = currentYear - i;
        return {
          text: year.toString(),
          value: year,
        };
      });
      this.yearsTo = yearsComplete.filter((year) => year.value !== newVal);
    },
  },
  mounted() {
    this.idCompany = JSON.parse(atob(localStorage.getItem("uid"))).idcompania;
    this.fetchToken();
    this.getLastTenYearsDesc();
  },
  computed: {
    filterAccountingAccountStart() {
      const query = this.searchAccountingAccountStart.toLowerCase();
      return this.accountingAccountOptions.filter((c) => {
        const matchesSearch = c.text.toLowerCase().includes(query);
        // 🔥 mantener seleccionados visibles
        const isSelected = this.dataTable.some(
          (row) => row.startAccount === c.value
        );

        return matchesSearch || isSelected;
      });
    },
    filterAccountingAccountEnd() {
      const query = this.searchAccountingAccountEnd.toLowerCase();
      return this.accountingAccountOptions.filter((c) => {
        const matchesSearch = c.text.toLowerCase().includes(query);
        // 🔥 mantener seleccionados visibles
        const isSelected = this.dataTable.some(
          (row) => row.endAccount === c.value
        );

        return matchesSearch || isSelected;
      });
    },
    filterReportValueColumn() {
      const query = this.searchReportValueColumn.toLowerCase();

      return this.reportValueColumnOptions.filter((c) => {
        const matchesSearch = c.text.toLowerCase().includes(query);

        // 🔥 mantener seleccionados visibles
        const isSelected = this.dataTable.some(
          (row) => row.formatColumnId === c.value
        );

        return matchesSearch || isSelected;
      });
    },
    filterOriginValue() {
      const query = this.searchOriginValue.toLowerCase();
      return this.optionsOriginValue.filter((c) =>
        c.description.toLowerCase().includes(query)
      );
    },
    filterAccountingConcept() {
      const query = this.searchAccountingConcept.toLowerCase();
      return this.accountingConceptOptions.filter((c) =>
        c.text.toLowerCase().includes(query)
      );
    },
    filterHConcept() {
      const query = this.searchHConcept.toLowerCase();
      return this.hConceptsAmount.filter((c) =>
        c.text.toLowerCase().includes(query)
      );
    },
    filteredTaxes() {
      if (!this.searchModalTaxes) return this.hTaxes;
      const term = this.searchModalTaxes.toLowerCase();

      return this.hTaxes.filter(
        (p) =>
          p.percentage.toLowerCase().includes(term) ||
          p.description.toLowerCase().includes(term)
      );
    },
  },
  methods: {
    openConceptModal() {
      if (!this.dataFilter.year) {
        this.setAlertTable("error", "Seleccione el año a configurar.");
        return;
      } else if (!this.dataFilter.format) {
        this.setAlertTable("error", "Seleccione el formato a configurar.");
        return;
      }

      this.conceptItem = [];
      this.showModalConcept = true;
    },
    addConceptAccounting(item, index) {
      this.indexConceptAccounting = index;

      if (item.hconceptsCfg?.length) {
        this.conceptAccountingItem = item.hconceptsCfg
          .map((existing) => {
            return this.hConceptsAmount.find(
              (option) => option.value === existing.id
            )?.value;
          })
          .filter(Boolean);
      } else {
        this.conceptAccountingItem = [];
      }

      this.showModalConceptAccounting = true;
    },
    addConceptToTable() {
      if (!this.conceptItem) return;

      const conceptKey = `${this.conceptItem.conceptCode} - ${this.conceptItem.description}`;

      this.dataTable.push({
        conceptDescription2: conceptKey,
        formatConceptId: this.conceptItem.id,
        startAccount: null,
        endAccount: null,
        formatColumnId: null,
        appliesTopAmount: false,
        topAmount: 0,
        calculationTypeId: null,
        ivaMayorValorCosto: false,
        hconceptsCfg: null,
      });

      this.setAlertTable("success", "Concepto agregado correctamente");
      this.showModalConcept = false;

      this.$nextTick(() => {
        const el =
          this.$refs.tableContainer ||
          document.querySelector('.v-data-table__wrapper');

        if (el) {
          el.scrollTo({
            left: 0,
            behavior: "smooth"
          });
        }
      });
    },
    addConceptAccountingToTable() {
      if (!this.conceptAccountingItem) return;

      const row = this.dataTable[this.indexConceptAccounting];

      if (!Array.isArray(row.hconceptsCfg)) {
        this.$set(row, "hconceptsCfg", []);
      }

      row.hconceptsCfg = this.conceptAccountingItem.map((c) => ({
        id: c,
      }));

      this.showModalConceptAccounting = false;
      this.setAlertTable(
        "success",
        "Conceptos Contables agregados correctamente"
      );
    },
    getLastTenYearsDesc() {
      const currentYear = new Date().getFullYear();
      const endYear = currentYear;

      this.years = Array.from({ length: 10 }, (_, i) => {
        const year = endYear - i;
        return {
          text: year.toString(),
          value: year,
        };
      });
    },
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },
    setAlertTable(type, message) {
      this.alertTypeTable = type;
      this.alertMessageTable = message;
      this.showAlertTable = true;
      setTimeout(() => (this.showAlertTable = false), 4000);
    },
    async fetchToken() {
      this.token = null;
      this.loading = true;
      try {
        const response = await axios.post(
          environment.HIOPOSWEBSERVICES + "/api/getTokenByCompany",
          {
            idcompania: JSON.parse(atob(localStorage.getItem("uid")))
              .idcompania,
          }
        );
        this.token = response.data.token;
        if (this.token) {
          await this.getDianFormats();
        } else {
          this.setAlert("error", "Error al obtener token");
        }
      } catch (e) {
        this.setAlert("error", "Error al obtener token");
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async getDianFormats() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${this.idCompany}/settings`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        );

        this.formats = response.data.formats;
        const accounts = response.data?.accounts;

        if (!accounts || accounts.length === 0) {
          this.accountingAccountOptions = [];
          this.showModalExist = true;
          return;
        }

        this.accountingAccountOptions = accounts.map((c) => ({
          value: c.account,
          text: `${c.account} - ${c.description}`,
        }));
        this.optionsOriginValue = response.data.calculationTypes;
        this.accountingCompanies =
          response.data.accountingCompanies?.[0]?.description ?? null;
        const hConcepts = response.data?.hconcepts;
        if (!hConcepts || hConcepts.length === 0) {
          this.hConceptsAmount = [];
          return;
        }
        this.hConceptsAmount = hConcepts.map((c) => ({
          value: c.hconceptCode,
          text: `${c.hconcept} - ${c.description}`,
        }));
        this.hTaxes = response.data?.htaxes;
        
        this.selectedTaxes = this.hTaxes
              ?.filter(tax => tax.isIvaMayorValorCosto)
              .map(tax => tax.id) || [];
      } catch (error) {
        console.error("Error al extraer los formatos de la dian:", error);
        this.setAlert("error", "Ocurrió un error durante la eliminacion.");
      } finally {
        this.loading = false;
      }
    },
    deleteConcept(item) {
      const initialLength = this.dataTable.length;

      this.dataTable = this.dataTable.filter((row) => row !== item);

      if (this.dataTable.length < initialLength) {
        this.setAlertTable("success", "Se eliminó el concepto");
      } else {
        this.setAlertTable("error", "No se pudo eliminar el concepto");
      }
    },
    tryFetchConfiguration() {
      if (!this.dataFilter.year || !this.dataFilter.format) return;

      const key = `${this.dataFilter.year}-${this.dataFilter.format}`;

      if (this.lastQueryKey === key) return;

      // Limpiar timeout anterior si existe
      if (this.fetchTimeout) {
        clearTimeout(this.fetchTimeout);
      }

      // Esperar 500ms antes de ejecutar
      this.fetchTimeout = setTimeout(() => {
        this.lastQueryKey = key;
        this.getConfiguration();
      }, 2500);
    },
    async getConfiguration() {
      try {
        this.loading = true;

        const response = await axios.get(
          `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${this.idCompany}/years/${this.dataFilter.year}/formats/${this.dataFilter.format}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        );

        if (response.data?.conceptsCfg?.length > 0) {
          this.dataTable = response.data.conceptsCfg;
          this.dataCredentials.topeLimite = response.data.topLiabilites;
          this.dataCredentials.topeA = response.data.topAmount;
          this.dataCredentials.topeB = response.data.topAmount2;
          this.dataCredentials.appliesGroupingByLackData =
            response.data.appliesGroupingByLackData;
          this.setAlertTable("success", "Configuración cargada exitosamente");
        } else {
          this.dataTable = [];
          this.dataCredentials = {
            topeLimite: 0,
            topeA: 0,
            topeB: 0,
            appliesGroupingByLackData: false,
          };
          this.setAlertTable("info", "No existe ninguna configuración");
        }
      } catch (error) {
        this.setAlertTable("error", "No se pudo cargar la configuración");
      } finally {
        this.loading = false;
      }
    },
    async saveConfigImport() {
      try {
        this.loading = true;

        const params = {
          topAmount: this.dataCredentials.topeA,
          topAmount2: this.dataCredentials.topeB,
          topLiabilities: this.dataCredentials.topeLimite,
          appliesGroupingByLackData:
            this.dataCredentials.appliesGroupingByLackData,
          conceptsCfg: this.dataTable,
        };

        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${this.idCompany}/years/${this.dataFilter.year}/formats/${this.dataFilter.format}`,
          params,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        );

        this.setAlertTable("success", "Configuración guardada correctamente");
      } catch (error) {
        this.setAlertTable("error", "Error al guardar la configuración");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    copyFormats() {
      this.showModalCopyFormat = true;
    },
    openModalTaxes() {
      this.showModalTaxes = true;
    },
    async saveConfigTaxes(){
      try {
        this.loading = true;
        this.showModalTaxes = false;
        let params =  this.hTaxes.map(tax => ({
                        id: tax.id,
                        isIvaMayorValorCosto: this.selectedTaxes.includes(tax.id),
                      }));
        
        const response = await axios.put(
          `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${this.idCompany}/htaxes`,
          params,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        );
        this.setAlertTable("success", "Configuración de impuestos guardada correctamente");
      } catch (error) {
        this.setAlertTable("error", "Error al guardar la configuración de impuestos");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    closeModalTax() {
      this.showModalTaxes = false
      this.selectedTaxes = this.hTaxes
              ?.filter(tax => tax.isIvaMayorValorCosto)
              .map(tax => tax.id) || [];
      
    },
    async copyFormatsYear() {
      try {
        this.loading = true;
        this.showModalCopyFormat = false;
        if (this.dataCopy.to == null || this.dataCopy.from == null || this.dataCopy.formats.length == 0) {
          this.loading = false;
          this.setAlertTable("warning", "Faltan campos requeridos para importar los formatos por año");
        }
        const payload = {
          targetYear: this.dataCopy.to,
          formats: this.dataCopy.formats.map(id => ({
            id
          }))
        };
        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${this.idCompany}/years/${this.dataCopy.from}/copy-config`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        );
        this.setAlertTable("success", "Importacion copiada correctamente");
      } catch (error) {
        this.setAlertTable(
          "error",
          `Error al copiar la importacion del año: ${this.dataCopy.from}`
        );
        console.error(error);
      } finally {
        this.dataCopy.from = null,
        this.dataCopy.to = null,
        this.dataCopy.formats = [],
        this.loading = false;
      }
    }
  },
};
</script>
<style scoped>
.line-text {
  border: 1px solid #dfdfdf !important;
  border-radius: 15px;
}
.pad-text {
  padding: 10px;
}
.just-cen {
  justify-content: center;
  text-align: center;
}
.max-height-select .v-select__selections {
  max-height: 80px;
  overflow-y: auto;
}
.tam-p {
  font-size: larger;
}
.permiso-lista {
  max-height: 350px; /* visible ~2 filas completas */
  overflow-y: auto;
  padding-right: 10px;
}

/* Scroll estilizado (opcional) */
.permiso-lista::-webkit-scrollbar {
  width: 6px;
}
.permiso-lista::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

/* Cards con mejor presentación */
.permiso-card {
  border-radius: 12px;
  transition: transform 0.2s ease;
}
.permiso-card:hover {
  transform: scale(1.03);
}
.permiso-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  padding: 20px;
  max-height: 400px; /* Ajusta según el alto que quieras mostrar */
  overflow-y: auto; /* Scroll vertical si hay muchos permisos */
  overflow-x: hidden;
  border-radius: 6px;
}

/* Scrollbar personalizado */
.permiso-cell::-webkit-scrollbar {
  width: 6px;
}

.permiso-cell::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
.dis-div {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}
.r-search {
  max-width: 70%;
  margin-right: 1%;
}
.c-black {
  font-size: x-large;
}
</style>
